import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { bindActionCreators } from "redux";
import "./checkBoxInput.scss"
import { useSelector } from "react-redux";
import { FormControl, InputLabel, MenuItem, Select, InputAdornment, Input, OutlinedInput, TextField } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { useDispatch } from "react-redux";
import { actionCreators } from "../../store";
import { RootState } from "../../store/reducers";
import Checkbox from '@mui/material/Checkbox';

export default function CheckBoxInput(props: any) {
  const { name, label, data, handleCheckbox, found } = props;
  const dispatch = useDispatch();
  const {
    freezScreenState,
    alertMessageState,
    setStoreId
  } = bindActionCreators(actionCreators, dispatch);
  const state = useSelector((state: RootState) => state.appReducer);
  const { userInfo, freezScreen } = state;
  const appState = useSelector((state: RootState) => state.apiReducer);
  const [options, setOptions] = useState<any[]>(data);


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let updatedOptions = [...options]; 
    const index = updatedOptions.findIndex(item => item.name === event.target.name);
    if (index !== -1) { 
        updatedOptions[index] = { ...updatedOptions[index], check_status: !updatedOptions[index].check_status };
    }
    setOptions(prevOptions => updatedOptions); 
    handleCheckbox(updatedOptions, name)

};

  useEffect(() => {
    setOptions(options ? options : data)
  }, [data])

  useEffect(() => {
      if(found != undefined){
        setOptions(found.value)
      }
  }, [found])
  




  return (

    <div id="CheckBoxInput" className="">
      <p className="mb-0 label mb-1 familysora600 text-capitalize">{label}</p>
      <FormControl className={`labelParent ${appState.langValue === "ar" ? "direction-ltr" : "direction-rtl"}`} size="small">
        {options?.map((v: any, i: any) => (
          <FormControlLabel
            key={v.id}
            control={
              <Checkbox
                checked={v.check_status}
                onChange={handleChange}
                name={v.name}
              />
            }
            label={v.name}
          />
        ))}
      </FormControl>
    </div>

  );
}
